import axios from '../../../requesters/axios'
import _ from 'lodash'

import {
  SWITCH_CHECKOUT_ACTIVE_ITEM,
  GET_CURRENT_USER_SUCCESS,
  GET_CURRENT_USER_FAILURE,
  CLEAN_CHECKOUT_CONTENT_STORE,
  LOAD_CLIENT_BY_PLATE
} from './types'


import { FETCH_MAKES_SUCCESS, GET_CAR_MAKE_SUCCESS } from '../../../actionTypes/make'
import { apiErrorHandler } from '../../../errors'
import { saveQueryParams } from '../actions'

export function switchCheckoutContent(content) {
  return (dispatch) => {
    dispatch({
      type: SWITCH_CHECKOUT_ACTIVE_ITEM,
      payload: {
        content,
      },
    });
  };
}

export function getCurrentUser() {
  return (dispatch) => {
    axios.get(`/me`).then(response => response.data.user)
      .then((user) => {
        // ReactGA.set({ emailHash: user.emailHash });
        if (user) {
          dispatch({
            type: GET_CURRENT_USER_SUCCESS,
            payload: {
              user
            }
          });
        } else {
          dispatch({ type: GET_CURRENT_USER_FAILURE });
        }
      })
      .catch((error) => {
        dispatch({ type: GET_CURRENT_USER_FAILURE })
      });
  };
}

export function loadClientByPlate(plate) {
  return (dispatch) => {
    const defaultAction = {
      type: LOAD_CLIENT_BY_PLATE,
      payload: {
        currentUser: null,
        finishedLoad: true
      }
    }

    if (!plate.startsWith('WEB_')) {
      axios.get(`/budgets/${plate.toUpperCase()}/loadClientData`)
        .then((response) => {
          if (response && response.data[0]) {
            dispatch({
              type: LOAD_CLIENT_BY_PLATE,
              payload: {
                currentUser: response.data[0],
                finishedLoad: true
              }
            })
          } else {
            dispatch(defaultAction)
          }
        }).catch(() => {
          dispatch(defaultAction)
        });
    } else {
      dispatch(defaultAction)
    }
  }
}

export function cleanCheckoutContentStore(props) {
  return (dispatch) => {
    dispatch({
      type: CLEAN_CHECKOUT_CONTENT_STORE,
      payload: {
        props
      }
    });
  };
}

export function fetchMakes() {
  return (dispatch => {
    axios.get('/makes')
      .then((response) => {
        dispatch({
          type: FETCH_MAKES_SUCCESS,
          payload: {
            makes: response.data,
          }
        })
      })
      .catch(apiErrorHandler);
  })
}


export function storeCarMakeIntoQueryParams(queryParams, makes) {
  return (dispatch) => {
    const make = _.find(makes, { make: queryParams.make }) || { models: [] };
    const model = _.find(make.models, { model: queryParams.model }) || { engines: [] };
    const engine = _.find(model.engines, { engineId: queryParams.engine }) || {};

    /* Create the model similar to the one retrieved from the db */
    const currentMake = {
      ...make,
      models: {
        ...model,
        engines: {
          ...engine
        }
      }
    }
    dispatch({
      type: GET_CAR_MAKE_SUCCESS,
      payload: {
        currentMake,
      }
    })

    dispatch(saveQueryParams({
      ...queryParams,
      year: !Number.isNaN(Number(queryParams.year)) ? Number(queryParams.year) : null,
      engine: engine.engine,
    }))

  }
}

const handleRedirect = (isAppointment, configuration) => {
  let url
  if (isAppointment) {
    url = configuration.redirects.graciasCita
  } else {
    url = configuration.redirects.graciasPpto
  }
  window.location.assign(url);
}

export function sendPickupMessage(budgetId, text, appointmentDataForm, configuration) {
  return (dispatch) => {
    axios.post(`/messages/budget/${budgetId}`, { text, isNotification: false, isAutomated: true })
      .then((response) => {
        handleRedirect(appointmentDataForm, configuration)
      })
      .catch(apiErrorHandler);
  }
}


// WEBPACK FOOTER //
// ./src/workflow/checkout/checkoutContent/actions.js